import { string, number } from 'prop-types';

const identificacionTypeBasicInformationPropTypes = {
  id: number,
  identificationInCountry: string,
  name: string,
};

export default identificacionTypeBasicInformationPropTypes;
